import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'

@Component({
  selector: 'app-error500',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './error500.component.html',
  styles: ``,
})
export class Error500Component {}
